export const BRAND = "chatblackhole.com";
export const PHONE = "+923366757846";
export const PHONE_LINK = "tel:+923366757846";
export const WA_LINK = "https://wa.me/923366757846";
export const EMAIL = "askmirza247@gmail.com";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SERVICE_OPTIONS = [
  "Websites & Mobile Applications",
  "AI Chatbots & Custom Bots",
  "Matlab, Mathematica & Python",
  "Research Articles & PhD Proposals",
  "Online Tutoring (Math, Physics, Stats)",
  "Urgent Turnaround Help",
];
